import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { paths } from '@/generated/api';
import { getAuthToken, setAuthToken } from './auth-token';

const API_BASE_URL = import.meta.env.API_URL;

const fetchClient = createFetchClient<paths>({ baseUrl: API_BASE_URL });

fetchClient.use({
  onRequest: ({ request }) => {
    // Native clients authenticate with a bearer token; web relies on cookies.
    const token = getAuthToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    return new Request(request, { credentials: 'include' });
  },
  onResponse: async ({ response }) => {
    // Mirrors auth-client.ts onSuccess. Any backend endpoint that issues a
    // session sets `set-auth-token`; capture it so native bearer auth survives
    // the post-exchange reload. setAuthToken is a no-op on web, so this stays
    // safe for the cookie flow.
    const token = response.headers.get('set-auth-token');
    if (token) await setAuthToken(token);
  },
});

export const $api = createClient(fetchClient);
export { fetchClient };
